function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2755"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18476",
  d: "M11.738 68.838a22.994 22.994 0 010-32.525L39.312 8.739a23 23 0 1132.527 32.525L44.263 68.838a22.994 22.994 0 01-32.525 0z",
  fill: "#fee8cc"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2760",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18517",
  d: "M22.321 30.66h-7.992a3.33 3.33 0 01-3.33-3.33V18",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18518",
  d: "M57.999 50.34h10.992a3.33 3.33 0 013.33 3.33V64",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18519",
  d: "M22.321 39H7.329",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18523",
  d: "M55.999 26h14.993",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18524",
  d: "M51.999 38h14.993",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18520",
  d: "M27.99 52H12.998",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18521",
  d: "M52 49.001v14.992",
  fill: "none",
  stroke: "#fb8c00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18522",
  d: "M29.998 27.001V12.009",
  fill: "none",
  stroke: "#1d1f2c",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2759"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1440",
  transform: "translate(19.999 19)",
  fill: "#fff",
  stroke: "#1d1f2c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 38,
  height: 38,
  rx: 4,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2758",
  stroke: "#fb8c00"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 351",
  transform: "translate(32.999 23)",
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 7,
  ry: 16,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 6,
  ry: 15
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 352",
  transform: "rotate(60 3.58 56.078)",
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 7,
  ry: 16,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 6,
  ry: 15
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 353",
  transform: "rotate(120 16.86 37.026)",
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 7,
  ry: 16,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7,
  cy: 16,
  rx: 6,
  ry: 15
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Ellipse 354",
  transform: "translate(36.999 36)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 2,
  fill: "none"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1441",
  transform: "translate(7.999 13.762)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1442",
  transform: "translate(2.999 36)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1447",
  transform: "translate(69.321 23)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1448",
  transform: "translate(65.321 35)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1444",
  transform: "translate(8.999 49)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1445",
  transform: "rotate(-90 59 10)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1446",
  transform: "rotate(90 12.998 20)",
  fill: "#fff",
  stroke: "#1d1f2c",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1443",
  transform: "translate(68.999 62)",
  fill: "#fff",
  stroke: "#fb8c00",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: -1,
  y: -1,
  width: 8,
  height: 8,
  rx: 2,
  fill: "none"
}))));

var SvgPostQuantum = function SvgPostQuantum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78.577,
    height: 77
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgPostQuantum as ReactComponent };